import React from 'react'
import styled from '@emotion/styled'

import { highlightBlueBase, fontWeightRegular, redLight10, fontSize2XSmall } from '../../constants/principles'

import Error from './Error'
import IneligibleDR from './IneligibleDR'

export default ({ isError, detail, kbbUrl, isAdmin, isDigitalRetail, isCobrandDR, year, make, model, trim, mileage, vin, isAssigned, offerCode }) => (
  <Error isError={isError} id={`${detail}-error`} testId={'bi-lb-mileage-error'} text={`Vehicles with more than 300,000 miles aren't eligible for an Instant Cash Offer${isDigitalRetail ? ', but the dealer might still take it as a trade in.' : '.'}`}>
    {isError &&
      offerCode.toUpperCase() !== 'TC' &&
      (isCobrandDR || (isDigitalRetail && offerCode.toUpperCase() === 'WC') ? (
        <IneligibleDR reason={'mileage was over 300000.'} vin={vin} year={year && year.yearId} make={make && make.makeId} model={model && model.modelId} trim={trim && trim.trimId} />
      ) : isAdmin || isAssigned ? (
        <StyledCta>Please verify the mileage you entered.</StyledCta>
      ) : (
        <StyledCta>
          Please verify the mileage you entered, or we can help you <StyledA href={trim && trim.trimId ? kbbUrl + `/find-trade-in-dealer/?vehicleId=${trim.trimId}&mileage=${mileage}` : kbbUrl + '/find-trade-in-dealer'}>find a local dealer</StyledA> to
          trade in your vehicle.
        </StyledCta>
      ))}
  </Error>
)

const StyledCta = styled.div`
  font-size: ${fontSize2XSmall};
  font-weight: ${fontWeightRegular};
  color: ${redLight10};
  display: 'flex';
  align-items: center;
  justify-content: center;
  text-align: center;
`
const StyledA = styled.a`
  text-decoration: none;
  color: ${highlightBlueBase};
  :hover {
    text-decoration: underline;
  }
`
